<script module lang="ts">
  import type { Styles } from '../../../../../panda/css';
  import type { Snippet } from 'svelte';

  export interface ComboboxContentProps {
    children?: Snippet;
    positionerStyles?: Styles;
  }
</script>

<script lang="ts">
  import { useComboboxContext } from '../use-combobox-context';
  import { comboboxStyles } from '../combobox.styles';
  import { portal } from '@zag-js/svelte';
  import { css } from '@agapi/ui/panda/css';
  import { ComboboxItem } from '..';
  /**
   * Combobox content component.
   * Renders the panel or popover with the combobox options.
   */
  const combobox = useComboboxContext();
  const classes = comboboxStyles.raw();
  // console.log(combobox.api)

  const { positionerStyles }: ComboboxContentProps = $props();

  const open = $derived(combobox.api.open)
</script>

<div use:portal {...combobox.api.getPositionerProps()} class={css(classes.positioner, positionerStyles)}>
  <ul {...combobox.api.getContentProps()} class={css(classes.content)}>
    {#each combobox.api.collection.items as item}
      <ComboboxItem item={item} />
    {/each}
  </ul>
</div>